// extracted by mini-css-extract-plugin
export default {"root":"_29QvS","small":"_3ayR4","normal":"_32l2o"};